import packageJson from '../../package.json';
import { UnauthorizedError } from 'utils/errors';

const { version } = packageJson;

// small timeout on server to not slow down SSR
// big timeout on client to decrease failures in slow networks
const timeoutMs = global.__SERVER__ ? 12000 : 60000;

export const ERRORS_TO_RETRY = [
  400,
  500,
  502,
  503,
  504,
];
export const UNAUTORIZED_ERROR = 401;

const fetchWithRetry = (url, options = {}, retries) => fetch(url, options)
  .then((res) => {
    if (res.ok) {
      return res;
    }
    if (res.status === UNAUTORIZED_ERROR) {
      throw new UnauthorizedError();
    }
    if (retries > 0 && ERRORS_TO_RETRY.includes(res.status)) {
      return fetchWithRetry(url, options, retries - 1);
    }
    return res;
  });

const fetchWithoutRetry = (url, options = {}) => fetch(url, options)
  .then((res) => {
    if (res.ok) {
      return res;
    }
    if (res.status === UNAUTORIZED_ERROR) {
      throw new UnauthorizedError();
    }
    return res;
  });

/**
 * fetchWithTimeout
 * @param {string} url
 * @param {object} options
 * @param {number} retries - number of fetch-level retries (default 3)
 * @param {boolean} disableRetries - if true, disables fetch-level retries (for Apollo GraphQL)
 */
export function fetchWithTimeout(url, options = {}, retries = 3, disableRetries = false) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  const headers = options?.headers || {};

  const updatedOptions = {
    ...(options || {}),
    headers: {
      ...headers,
      ...(headers.authorization || headers.Authorization ? { 'cache-control': 'no-cache' } : {}),
      'mdm-client-name': 'web',
      'mdm-client-version': version,
    },
    signal: controller.signal,
  };

  if (disableRetries) {
    // No retry logic, just timeout
    return fetchWithoutRetry(url, updatedOptions).finally(() => clearTimeout(timeout));
  }
  return fetchWithRetry(url, updatedOptions, retries).finally(() => clearTimeout(timeout));
}
